<template>
  <aside class="menu app-sidebar fct-sidebar animated" :class="{ slideInLeft: show, slideOutLeft: !show }">
    <a href="" class="is-hidden-mobile" style="width: 100%">
      <img class="logo-img" src="../../assets/logo_white.svg" alt="Logo">
    </a>
    <user-menu class="is-hidden-tablet" @toggle="toggleUserMenu" @close="() => userMenuOpened = false"
               :is-opened="userMenuOpened"
               :full-name="user.name"></user-menu>
    <div class="menu-list">
      <ul :style="{display: displayMenu ? 'block' : 'none'}">
        <li v-for="(item, index) in menu" v-if="!item.hidden"
            :class="{expanded: isExpanded(item), active: isActive(item)}">
          <router-link :to="item.path" :exact="true" :aria-expanded="isExpanded(item) ? 'true' : 'false'"
                       v-if="item.path"
                       @click.native="toggle(index, item)">
            <span class="icon is-small"><i :class="['fct-admin-icon-' + item.meta.icon]"></i></span>
            {{ item.meta.label || item.name }}
            <span class="icon is-angle" v-if="hasVisibleChildren(item)">
            <i class="fa fa-angle-down"></i>
          </span>
          </router-link>
          <a :aria-expanded="isExpanded(item)" v-else @click="toggle(index, item)">
            <span class="icon is-small"><i :class="['fct-admin-icon-' + item.meta.icon]"></i></span>
            {{ item.meta.label || item.name }}
            <span class="icon is-angle" v-if="item.children && item.children.length">
            <i class="fa fa-angle-down"></i>
          </span>
          </a>
          <expanding v-if="hasVisibleChildren(item)">
            <ul v-show="isExpanded(item)">
              <li v-for="subItem in item.children" v-if="subItem.path">
                <router-link :to="generatePath(item, subItem)">
                  {{ subItem.meta && subItem.meta.label || subItem.name }}
                </router-link>
              </li>
            </ul>
          </expanding>
        </li>
      </ul>
    </div>
    <user-menu class="is-hidden-mobile" @toggle="toggleUserMenu" :is-opened="userMenuOpened"
               :full-name="user.name"></user-menu>
    <!--<h3 v-for="type in projectTypes">{{projectsCount[type]}} {{type | capitalize}} Projects</h3>-->
  </aside>
</template>

<script>
import Expanding from 'vue-bulma-expanding'
import {mapGetters, mapActions} from 'vuex'
import userResource from '../../views/projects/resources/UserResource'
import accountResource from "../../views/usersManager/resources/accountResource";
import storeUtils from '../../views/projects/mixins/storeUtils'
import UserMenu from './partials/UserMenu'
import LoadingHandler from "../../mixins/LoadingHandler"
import SubscriptionHandler from "../../views/businessProjects/create/mixins/SubscriptionHandler";

async function getSubscription() {
  return (await accountResource.getActiveSubscription()).subscription || (await accountResource.getCancelledSubscription()).subscription
}

function getDateFromObjectId(objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

function titlelize(name) {
  return name.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
}

export default {
  mixins: [storeUtils, LoadingHandler, SubscriptionHandler],
  components: {
    Expanding,
    UserMenu
  },

  props: {
    show: Boolean
  },

  data() {
    return {
      isReady: false,
      ddVisible: false,
      cpdVisible: false,
      userActionsOpen: false,
      displayMenu: false,
      userMenuOpened: false
    }
  },

  async mounted() {
    let route = this.$route
    if (route.name) {
      this.isReady = true
      this.shouldExpandMatchItem(route)
    }
    if (this.$auth.check()) {
      let [user, subscription] = await Promise.all([userResource.get(), getSubscription()])

      window.Intercom("boot", {
        app_id: "skf2whvi",
        name: titlelize(user.name), // Full name
        email: user.email, // Email address
        user_id: user.id,
        created_at: getDateFromObjectId(user.id)
      });
      this.setSubscription(subscription)
      this.setUser(user)
      this.toggleSidebar({hidden: false, opened: !this.$store.getters.device.isMobile})
      this.displayMenu = true
      await this.initPlanPrices() //temp
    } else {
      this.displayMenu = true
    }
  },

  computed: mapGetters({
    menu: 'authorizedmenuitems',
    user: 'user',
    projectsCount: 'projectsCount'
  }),

  methods: {
    ...mapActions([
      'expandMenu',
      'setUser',
      'setSubscription',
      'toggleSidebar'
    ]),

    toggleUserMenu() {
      this.userMenuOpened = !this.userMenuOpened
    },

    closeCPD() {
      this.cpdVisible = false
    },

    openChangePasswordsDialog() {
      this.cpdVisible = true
    },

    isExpanded(item) {
      return item.meta.expanded
    },

    hasVisibleChildren(item) {
      return item.children && item.children.filter(c => !c.hidden).length
    },

    isActive(item) {
      let that = this

      function itemActive(item) {
        return item.path && item.path === that.$route.path.split('/').slice(0, 3).join('/')
      }

      if (item.children) {
        return !!item.children.find(c => itemActive(c))
      }

      return itemActive(item)
    },

    toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      })
    },

    shouldExpandMatchItem(route) {
      let matched = route.matched
      let lastMatched = matched[matched.length - 1]
      let parent = lastMatched.parent || lastMatched
      const isParent = parent === lastMatched

      if (isParent) {
        const p = this.findParentFromMenu(route)
        if (p) {
          parent = p
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        })
      }
    },

    generatePath(item, subItem) {
      return `${item.component ? item.path + '/' : ''}${subItem.path}`
    },

    findParentFromMenu(route) {
      const menu = this.menu
      for (let i = 0, l = menu.length; i < l; i++) {
        const item = menu[i]
        const k = item.children && item.children.length
        if (k) {
          for (let j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item
            }
          }
        }
      }
    }
  },
  watch: {
    $route(route) {
      this.isReady = true
      this.userMenuOpened = false
      this.stopLoading()
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/derived-variables';
@import '~bulma/sass/utilities/mixins';
@import '../../../sass/fct/variables';

.animated {
  @include mobile {
    animation-duration: 0.5s !important;
    .mobile-top-img {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;

      > img {
        width: 100%;
        height: auto;
      }
    }

    background-color: #fff;
  }
}

#app.app-login {
  .app-sidebar.fct-sidebar {
    display: none;
  }
}

.app-sidebar.fct-sidebar {
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  min-width: 45px;
  width: 250px;

  @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    max-height: 100vw !important;
  }
  height: 100%;
  z-index: 1024 - 1;
  background-size: cover;
  box-shadow: 5px 5px 5px rgba(17, 17, 17, 0.1);

  @include mobile() {
    box-shadow: 4px 0px 8px rgba(40, 46, 54, 0.1);;
  }
  overflow-y: auto;
  overflow-x: hidden;


  @include mobile() {
    transform: translate3d(-180px, 0, 0);
  }

  @include tablet() {
    padding-top: 12px;
    background-image: url(../../assets/sidebar-bg.png);
  }

  span.icon.is-small {
    font-size: 16px;
    transform: translateY(-3px);
    @include mobile() {
      color: $md-grey;
    }
  }

  .logo-img {
    padding: 50px 0;
  }

  .icon {
    vertical-align: baseline;
    color: #fff;


    &.is-angle {
      position: absolute;
      right: 60px;
      transition: transform .377s ease;
    }

    &.is-small {
      position: absolute;
      left: 20px;
      top: 13px;

      @include mobile() {
        left: 16px;
      }
    }
  }

  .menu-label {
    padding-left: 5px;
  }

  .menu-list {
    @include mobile() {
      padding-top: 40px;
    }

    > ul {
      margin-top: 100px;

      @include mobile() {
        margin-top: 0;
      }

      > li {
        margin-bottom: 3px;

        > a {
          line-height: 1.6;
          margin: 0 20px;
          height: 38px;
          border-radius: 20px;
        }

        a {
          text-align: left;

          @include tablet() {
            padding: 0.55em 0 0 48px;
          }

          @include mobile() {
            padding: 0.55em 0 0 43px;
            color: #333;
          }
          /*line-height: 1.6;*/
          font-weight: 600;
          color: #fff;
          position: relative;
          background-color: inherit;

          /*padding-left: 18px;*/
          /*padding-bottom: 4px;*/
          &[aria-expanded="true"] {
            .is-angle {
              transform: rotate(180deg);
            }
          }
        }

        &.active {
          > a {
            background-color: rgba(20, 30, 30, 0.4);

            @include mobile() {
              background-color: rgba($active-color, 0.1);
              color: $active-color;
            }
          }

          li {
            a {
              line-height: 1.6;
              color: $default-color;

              &:hover {
                color: #fff;
              }

              &.is-active {
                color: $active-color;
              }
            }
          }


          .icon.is-small {
            color: $active-color;
          }
        }
      }
    }
  }
}
</style>
